<template>
    <div>
        <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'left'}"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                property="name"
                label="ชื่อร้าน"
                width="140">
            </el-table-column>
            <el-table-column
                property="address"
                label="ที่อยู่"
                width="320">
            </el-table-column>
            <el-table-column
                property="action"
                label="Action"
                width="120">
            </el-table-column>
            <el-table-column
                property="at"
                label="At"
                width="120">
            </el-table-column>
            <el-table-column
                property="courier"
                label="ขนส่ง"
                width="100">
            </el-table-column>
            <el-table-column
                property="Somthing"
                label="เหตุผล"
                width="160">
            </el-table-column>
            <el-table-column
                property="name"
                label="By"
                width="160">
            </el-table-column>
        </el-table>
        <div class="block Booking-page-pad">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage2"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="sizes, prev, pager, next"
                :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            tableData: [{
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }, {
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }, {
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }, {
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }, {
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }, {
                date: '12345678',
                name: 'Fillgoods Shop',
                address: '119 ถ.พระราม 4 แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110',
                action: 'แก้ไขเวลา',
                courier: 'SCG',
                Somthing: 'Somthing nana',
                at: '08.00 am'
            }],
            multipleSelection: []
        }
    },

    methods: {
        toggleSelection (rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },
        handleSelectionChange (val) {
            this.multipleSelection = val
        }
    }
}
</script>

<style lang="scss" scoped>
    .shiptable-text-center{
        text-align: center;
    }
    .Booking-page-pad{
        padding-top: 20px;
    }
</style>
